const encoder = new TextEncoder();

export async function hashText(text: string): Promise<string> {
  return await hashBuffer(encoder.encode(text));
}

export async function hashBuffer(buffer: Uint8Array): Promise<string> {
  const hashBuffer = await crypto.subtle.digest('SHA-1', buffer);

  return Array.from(new Uint8Array(hashBuffer), (byte) => byte.toString(16).padStart(2, '0')).join('');
}
